import React, { useState, useEffect, useMemo, useRef } from 'react';
import './hero1.css';
import { useNavigate } from 'react-router-dom';
// Import your background image from src/assets
import heroImage from '../assets/your-hero-image.png'; // Update with your image name
// import aboutImage from '../assets/about-image.jpg';
import aboutImage1 from '../assets/about-image1.png'; // Add your images
import aboutImage2 from '../assets/about-image2.png';
import aboutImage3 from '../assets/about-image3.png';
import aboutImage4 from '../assets/about-image4.png'; // Update with your image name
import rajasthanImg from '../assets/rajasthan.png';
import lehLadakhImg from '../assets/destinations/leh-ladakh.png';
import andamanImg from '../assets/destinations/andaman.png';
import kashmirImg from '../assets/destinations/kashmir.png';
import madhyaPradeshImg from '../assets/destinations/madhya-pradesh.png';
import keralaImg from '../assets/destinations/kerala.png';
import westBengalImg from '../assets/destinations/west-bengal.png';
import tamilNaduImg from '../assets/destinations/tamil-nadu.png';
import himachalPradeshImg from '../assets/destinations/himachal-pradesh.png';
import bhopal from '../assets/destinations/Bhopal/bhopal1.jpg';
import bhopal1 from '../assets/destinations/Bhopal/bhopal.jpg';
import bhopal2 from '../assets/destinations/Bhopal/tawa.jpg';
import bhopal3 from '../assets/destinations/Bhopal/pachmarhi.jpg';
import madhai from '../assets/destinations/Bhopal/madhai.jpg';
import gwalior from '../assets/destinations/Gawlior/gwalior_cover.jpg';
import gwalior1 from '../assets/destinations/Gawlior/gwalior.jpg';
import gwalior2 from '../assets/destinations/Gawlior/orcha.jpg';
import gwalior3 from '../assets/destinations/Gawlior/khajuraho.jpg';
import maheshwar from '../assets/destinations/Maheshwar/hanuwantiya.jpg';
import maheshwar1 from '../assets/destinations/Maheshwar/maheshwar.png';
import maheshwar2 from '../assets/destinations/Maheshwar/mandu.jpg';
import indore from '../assets/destinations/Indore/indore.jpg';
import indore1 from '../assets/destinations/Indore/maheshwar.jpg';



const Hero = () => {
  const navigate = useNavigate();
 
  const [isHovered, setIsHovered] = React.useState(false);


  const [location, setLocation] = useState('');
  // const [checkIn, setCheckIn] = useState('');
  // const [checkOut, setCheckOut] = useState('');

  // ✅ NEW: State for modal
  const [selectedDestination, setSelectedDestination] = useState(null);
  // const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // ✅ Location to route mapping
  const locationRoutes = {
    'India': '/india',
    'Madhya Pradesh': '/india/madhya-pradesh',
    'Uttar Pradesh': '/india/uttar-pradesh',
    'Rajasthan': '/india/rajasthan',
    'Gujarat': '/india/gujarat',
    'Daman': '/india/daman',
    'Maharashtra': '/india/maharashtra',
    'Himachal Pradesh': '/india/himachal-pradesh',
    'Jammu & Kashmir': '/india/jammu-kashmir',
    'Ladakh': '/india/ladakh',
    'Uttarakhand': '/india/uttarakhand',
    'Goa': '/india/goa',
    'Kerala': '/india/kerala',
    'Karnataka': '/india/karnataka',
    'Tamil Nadu': '/india/tamil-nadu',
    'Andhra Pradesh': '/india/andhra-pradesh',
    'Andaman & Nicobar': '/india/andaman-nicobar',
    'West Bengal': '/india/west-bengal'
  };

  // ✅ Location to route mapping
  const handleSearch = (e) => {
    e.preventDefault();
    
    if (!location) {
      alert('Please select a destination');
      return;
    }

    // ✅ Updated handleSearch with navigation
    const route = locationRoutes[location];
    if (route) {
      navigate(route);
    } else {
      console.log('Search:', { location });
      alert(`Searching for: ${location}`);
    }
  };

  // Services data
  const services = [
    {
      id: 1,
      title: "Domestic Packages",
      icon: "fas fa-map-marked-alt",
      bgColor: "#a7f3d0", // Light green
      iconColor: "#065f46"
    },
    {
      id: 2,
      title: "International Packages",
      icon: "fas fa-globe-americas",
      bgColor: "#bfdbfe", // Light blue
      iconColor: "#1e40af"
    },
    {
      id: 3,
      title: "Flight Bookings",
      icon: "fas fa-plane",
      bgColor: "#93c5fd", // Medium blue
      iconColor: "#1e40af"
    },
    {
      id: 4,
      title: "Visa",
      icon: "fas fa-passport",
      bgColor: "#7dd3fc", // Sky blue
      iconColor: "#0c4a6e"
    },
    {
      id: 5,
      title: "Adventure and Activities",
      icon: "fas fa-heart",
      bgColor: "#ddd6fe", // Light purple
      iconColor: "#6b21a8"
    },
    {
      id: 6,
      title: "hotel and transport",
      icon: "fas fa-bus",
      bgColor: "#ddd6fe", // Light purple
      iconColor: "#6b21a8"
    }
  ];

  

  const aboutServices = [
    // 'Travel Packages',
    // 'Hotel',
    // 'Transportation',  
    // 'Air Ticket',
    // 'Visa'
  ];

  const aboutImages = [
    // aboutImage1,
    // aboutImage2,
    // aboutImage3,
    aboutImage4
  ];



  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-slide functionality
  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % aboutImages.length
      );
    }, 4000); // Change image every 4 seconds

    return () => clearTimeout(timer);
  }, [currentImageIndex, aboutImages.length]);


  const mpdestinations = [
    {
      id: 1,
      name: "BHOPAL, TAWA, MADHAI, PACHMARHI",
      image: bhopal,
      size: "medium",
      duration: "6 Days / 5 Nights",
      price: "₹0",
      images: [bhopal1, bhopal2, bhopal3],
      about: "Experience the rich heritage of Bhopal, Unesco heritage site, etc.",
      highlights: [
        "The City of Lakes",
        "UNESCO Heritage Site",
        "Ratapani Wildlife Sanctuary",
        "Serene Reservoir Amidst Greenery",
        "Gateway to Satpura's Exquisite Forests",
        "Pachmarhi - Queen of Satpura"
      ],
      included: [
        "	The costing is based on per person basis.",
        "	Meal plan as per hotel tariff",
        "AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers – pickup from Nagpur to Drop at Bhopal."

      ],
      excluded: [
        "	Anything not mentioned in Inclusions",
"	Safari charges are not included",
"	Entry Fee for any sightseeing, Monuments etc",
"	Air or Train Fare"

      ],
      itinerary: [
        {
          day: 1,
          title: "Bhopal - The City of Lakes",
          description: "Embark on an exciting road trip from the vibrant city of Bhopal, surrounded by picturesque landscapes. Explore the serene beauty of the lakes, with the Boat Club offering enchanting boat rides. Start your sightseeing early to make the most of the day."
        },
        {
          day: 2,
          title: "Bhimbetka - UNESCO Heritage Site",
          description: "Travel approximately 45 km from Bhopal to Bhimbetka, known for its UNESCO World Heritage caves. This historic site, steeped in legend from the Mahabharata, is a haven for adventure seekers, historians, and nature lovers."
        },
        {
          day: 3,
          title: "Amargarh Waterfalls - Ratapani Wildlife Sanctuary",
          description: "Head southeast about 60 km from Bhopal to reach the Amargarh Waterfalls within the Ratapani Wildlife Sanctuary. Embrace the lush surroundings and relish the tranquility of this picturesque destination, especially captivating during the monsoon."
        },
        {
          day: 4,
          title: "Tawa Dam - Serene Reservoir Amidst Greenery",
          description: "Travel approximately 80 km from Amargarh Waterfalls to reach Tawa Dam, nestled amidst lush greenery. Enjoy enchanting sunsets over the dam and embark on a serene lake cruise, offering breathtaking views of little islands and the Satpura hills."
        },
        {
          day: 5,
          title: "Madai - Gateway to Satpura's Exquisite Forests",
          description: "Madhai, located at the entrance of the enchanting Satpura forests, offers absolute tranquility and mystique. Delight in its rich wildlife, sprawling meadows, and spellbinding views, immersing yourself in nature's magic."
        },
        {
          day: 6,
          title: "Pachmarhi - Queen of Satpura",
          description: "Conclude your road trip in Pachmarhi, a favoured destination in Madhya Pradesh. Marvel at scenic waterfalls and lush green valleys, making it an ideal picnic spot. Experience the captivating beauty of Pachmarhi, especially during the monsoon season. Pack your bags and set off on a memorable road trip across Madhya Pradesh, known as the Heart of Incredible India. This journey promises not just exploration but a treasure trove of cherished memories amidst nature's grandeur."
        }
      ]
    },
    {
      id: 2,
      name: "TAWA, MADHAI, PACHMARHI",
      image: bhopal3,
      size: "medium",
      duration: "5 Days / 4 Nights",
      price: "₹0",
      images: [bhopal2, madhai, bhopal3],
      about: "Discover Pachmarhi, the Queen of Satpura. Explore beautiful waterfalls, ancient caves, and lush green valleys in this hill station.",
      highlights: [
        "Arrival and Tawa Exploration",
        "Madhai Wilderness",
        "Wildlife Expedition to Pachmarhi",
        "Pachmarhi Exploration",
        
      ],
      included: [
        "The costing is based on per person basis.",
        "Meal plan as per hotel tariff",
        "AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers - pickup from Nagpur to Drop at Bhopal.",
        
      ],
      excluded: [
        "Anything not mentioned in Inclusions",
        "Safari charges are not included",
        "Open gypsy at Pachmarhi not included",
        "Entry Fee for any sightseeing, Monuments etc",
        "Air or Train Fare"
      ],
      itinerary: [
        {
          day: 1,
          title: "Arrival and Tawa Exploration",
          description: ["Morning arrival in Bhopal via Train/Flight/Bus.",
            "Welcome & Check-In followed by breakfast/refreshments at the hotel.",
            "Journey to Tawa (120 Kms) with a stop at Bhimbetka on route.",
            "Check-In at Hotel Tawa Resort, lunch, and relaxation.",
            "Evening stroll to the Dam, enjoy Evening Tea, followed by dinner & overnight stay."
          ]

        },
        {
          day: 2,
          title: "Madhai Wilderness",
          description: ["Breakfast and departure for Madhai (50 Kms) via a scenic Motor Boat (Jalpari) - 2 hours journey.",
            "Check-In at Bison Resort, Madhai. Lunch at leisure",
            "Evening Park Safari Round & Tea, optional Night Park Safari Round/Nature Walk.",
            "Dinner & Overnight stay amidst the wilderness.",
          ]
        },
        {
          day: 3,
          title: "Wildlife Expedition to Pachmarhi",
          description: ["Morning Park Safari round followed by breakfast.",
            "Departure for Pachmarhi (90 Kms) post lunch.",
            "Check-In at Hotel Highland, Tea, Dinner & Overnight stay."
          ]
        },
        {
          day: 4,
          title: "Pachmarhi Exploration",
          description: ["Full-day sightseeing after breakfast.",
            "Lunch amidst nature, enjoy Evening Tea, Dinner & Overnight stay."
          ]
        },
        {
          day: 5,
          title: "Departure and Shopping",
          description: ["Breakfast followed by a free morning for shopping or personal exploration.",
"Lunch and departure for Bhopal (200 Kms) to conclude the tour.",
"This updated itinerary highlights the natural wonders and wildlife experiences across Tawa, Madhai, and Pachmarhi, allowing travellers to immerse themselves in the scenic beauty and wildlife while ensuring comfortable stays and well-paced exploration."
          ]
        }
      ]
    },
    {
      id: 3,
      name: "GWALIOR, ORCHHA, KHAJURAHO",
      image: gwalior,
      size: "medium",
      duration: "5 Days / 4 Night",
      price: "₹0",
      images: [gwalior1, gwalior2, gwalior3],
      about: "This Heritage Circuit traces the royal and spiritual evolution of Madhya Pradesh. From the soaring ramparts of Gwalior Fort and the riverside medieval charm of Orchha, to the world-renowned erotic architecture of the Khajuraho temples.",
      highlights: [
        "Gwalior Fort, Jai Vilas Palace, Tansen Tomb, Gujari Mahal, Gurudwara Data Bandi Chhor Sahib, etc",
        "Orchha Fort, Jahangir Mahal, Raja Ram Mandir, Chaturbhuj Temple etc.",
        "Khajuraho Heritage",
        "Raneh Fall/Ken Gadiyal Sanctuary/Pandav fall",
        
      ],
      included: [
        "	The costing is based on per person basis.",
"	Meal plan as per hotel tariff",
"	AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers – pickup from Nagpur to Drop at Bhopal."
      ],
      excluded: [
        "	Anything not mentioned in Inclusions",
"	Safari charges are not included",
"	Entry Fee for any sightseeing, Monuments etc",
"	Air or Train Fare",

      ],
      itinerary: [
        {
          day: 1,
          title: "Gwalior Welcome",
          description: "Pickup from Gwalior Airport and transfer to the hotel and complete the check-in process. After get freshen up move to visit – Gwalior Fort, Jai Vilas Palace, Tansen Tomb, Gujari Mahal, Gurudwara Data Bandi Chhor Sahib, etc. Evening you can opt to go for local market visit to explore the Delicate and light cotton along with Maheshwari and Chanderi Silk Saris. The dinner and a cozy overnight stay at hotel."
        },
        {
          day: 2,
          title: "Orchha Expedition",
          description: "Start the day with a fulfilling breakfast and complete the checkout process. Later depart for Orchha (120 Kms). On arrival check-in to the hotel and after take rest proceed to visit – Orchha Fort, Jahangir Mahal, Raja Ram Mandir, Chaturbhuj Temple etc. In the evening you opt to visit light & sound show (on additional charges basis). Dinner and overnight stay at hotel."
        },
        {
          day: 3,
          title: "Khajuraho Heritage",
          description: "Rise and shine with breakfast and checkout depart for Khajuraho (170 Kms), where Hotel Payal awaits your check-in. You can opt to go to STATE MUSEUM OF TRIBAL AND FOLK ARTS (on additional charges basis) and in the evening there will be an option to visit “Light and Sound Show” (on additional charges basis). Later get back to the hotel for dinner and comfortable overnight stay."
        },
        {
          day: 4,
          title: "Discovering Khajuraho's Beauty",
          description: "After breakfast, delve into a full-day excursion exploring – Easter and Western Group of Temple in the first half and later opt to go to visit - Raneh Fall/Ken Gadiyal Sanctuary (25 Kms)/Pandav fall. Unwind with an evening tea and savor dinner before a peaceful overnight stay."
        },
        {
          day: 5,
          title: "Departure from Khajuraho",
          description: "Enjoy breakfast before checkout and later departing to drop at Khajuraho Airport/Railway Station."
        }
      ]
    },
    // Add more destinations with similar structure...
    {
      id: 4,
      name: "ORCHHA, KHAJURAHO",
      image: gwalior2,
      size: "medium",
      duration: "4 Days / 3 Night",
      price: "₹0",
      images: [ gwalior2, gwalior3],
      about: "This itinerary connects two of Central India's historical gems: the riverside palaces of Orchha and the famed UNESCO World Heritage temples of Khajuraho.",
      highlights: ["Orchha Exploration", "Khajuraho Journey", "Khajuraho Marvels & Natural Wonders"],
      included: [
        "	The costing is based on per person basis.",
        "	Meal plan as per hotel tariff",
        "	AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers – pickup from Nagpur to Drop at Bhopal."
      ],
      excluded: [
        "	Anything not mentioned in Inclusions",
        "	Safari charges are not included",
        "	Entry Fee for any sightseeing, Monuments etc",
        "	Air or Train Fare",

      ],
      itinerary: [
        {
          day: 1,
          title: "Jhansi Arrival & Orchha Exploration",
          description: ["Arrive at Jhansi Railway Station, then transfer to Orchha (17 Kms).",
            "Check into Hotel Betwa Retreat, relax, and enjoy a delectable lunch.",
            "Explore the Ramraja Temple, followed by a delightful evening tea.",
            "Immerse in the captivating SEL Show, and savor a delicious dinner. Overnight stay at the hotel."
            
          ]

        },
        {
          day: 2,
          title: "Orchha Adventure & Khajuraho Journey",
          description: ["Enjoy breakfast before engaging in optional River Rafting or Half-Day Sightseeing.",
            "Depart for Khajuraho (170 Kms) with a visit to Dubela Museum on route.",
            "Check into Payal Hotel, relish evening tea, and attend the SEL Show. Dinner and overnight stay at the hotel."
            ]
        },
        {
          day: 3,
          title: "Khajuraho Marvels & Natural Wonders",
          description: ["Start the day with breakfast and embark on a full-day excursion.",
            "Explore the Raneh Falls, Ken Gadiyal Sanctuary (25 Kms), and Pandav Falls.",
            "Enjoy a leisurely lunch and unwind with evening tea. Dinner and overnight stay at the hotel."
          ]
        },
        {
          day: 4,
          title: "Departure to Jhansi/Satna",
          description: ["After breakfast, depart for Jhansi (170 Kms) or Satna (120 Kms) as per your departure schedule.",
            "Drop-off at Jhansi/Satna Railway Station to conclude the tour."
          ]
        } 
      ]
    },
    {
      id: 5,
      name: "HANUWANTIYA, MAHESHWAR, MANDU",
      image: maheshwar2,
      size: "medium",
      duration: "4 Days / 3 Night",
      price: "₹0",
      images: [maheshwar, maheshwar1, maheshwar2],
      about: "This 4-day loop from Indore showcases the diverse spirit of Madhya Pradesh, transitioning from the serene island life and water activities at Hanuwantiya on the Tawa Dam to the deep spiritual history of Maheshwar, before concluding amidst the historical grandeur of the fortress city of Mandu.",
      highlights: ["Maheshwar Exploration", "Discovering Mandu"],
      included: [
        "	The costing is based on per person basis.",
        "	Meal plan as per hotel tariff",
        "	AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers – pickup from Nagpur to Drop at Bhopal."
      ],
      excluded: [
        "	Anything not mentioned in Inclusions",
        "	Safari charges are not included",
        "	Entry Fee for any sightseeing, Monuments etc",
        "	Air or Train Fare",

      ],
      itinerary: [
        {
          day: 1,
          title: "Indore Arrival & Hanuwantiya Retreat",
          description: ["Arrive in Indore via morning Train/Flight/Bus. Welcome, check-in, and breakfast/refreshments at the hotel.",
          "Journey from Indore to Hanuwantiya (130 Kms), arriving at the House Boat. Enjoy lunch and explore the surroundings.",
          "Evening tea, dinner, and overnight stay at Hanuwantiya."
          ]

        },
        {
          day: 2,
          title: "Maheshwar Exploration",
          description: ["Post breakfast, depart for Maheshwar (150 Kms). Check into Narmada Retreat, Maheshwar, and have lunch.",
            "Explore Maheshwar, take in its sights, and enjoy evening tea, dinner, and an overnight stay.",
          ]
        },
        {
          day: 3,
          title: "Discovering Mandu",
          description: ["After breakfast, head to Mandu (65 Kms). Enjoy a full day of sightseeing, with lunch included.",
            "Relax with evening tea, dinner, and stay overnight in Mandu."
          ]
        },
        {
          day: 4,
          title: "Departure from Mandu",
          description: ["After breakfast, continue sightseeing in Mandu and have lunch.",
"Depart for Indore (99 Kms) for your onward journey.",
"Experience the heritage and beauty of these locations on a 4-day exploration of Indore, Hanuwantiya, Maheshwar, and Mandu."
          ]
        } 
      ]
    },
    {
      id: 6,
      name: "INDORE, MAHESHWAR",
      image: indore,
      size: "medium",
      duration: "3 Day/3 Night",
      price: "₹0",
      images: [indore, indore1],
      about: "This 3-day itinerary offers a compelling cultural and scenic journey through the heart of Madhya Pradesh. Starting with the unique 'island life' experience at Hanuwantiya, the tour proceeds to the revered riverside temple town of Omkareshwar and the historical spiritual center of Maheshwar, balancing leisure, devotion, and heritage.",
      highlights: ["Unique stay on a houseboat at Hanuwantiya dam backwaters.", "Spiritual visits to the Jyotirlinga shrines at Omkareshwar.", "Exploration of the ancient ghats and handloom traditions of Maheshwar."],
      included: [
        "	The costing is based on per person basis.",
        "	Meal plan as per hotel tariff",
        "	AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers – pickup from Nagpur to Drop at Bhopal."
      ],
      excluded: [
        "	Anything not mentioned in Inclusions",
        "	Safari charges are not included",
        "	Entry Fee for any sightseeing, Monuments etc",
        "	Air or Train Fare",

      ],
      itinerary: [
        {
          day: 1, 
          title: "Arrival in Indore", 
          description: [
            "Arrive in Indore via morning Train, Flight, or Bus.",
            "Welcoming check-in and breakfast/refreshments at the hotel.",
            "Departure from Indore to Hanuwantiya (130 Kms).",
            "Upon arrival at Hanuwantiya, settle into the House Boat, followed by lunch and sightseeing.",
            "Enjoy Evening Tea, Dinner, and Overnight stay at Hanuwantiya."
          ]
        },
        {
          day: 2,
          title: "Exploration of Omkareshwar and Maheshwar",
          description: [
            "Begin the day with breakfast before heading to Maheshwar (150 Kms).",
            "En-route, stop for lunch and sightseeing at Omkareshwar (85 Kms).",
            "Arrival in Maheshwar and check-in at Narmada Retreat.",
            "Evening Tea, Dinner, and Overnight stay in Maheshwar."
          ]
        },
        {
          day: 3,
          title: "Maheshwar Sightseeing and Return to Indore",
          description: [
            "Start the day with breakfast and a sightseeing tour in Maheshwar.",
            "Enjoy lunch and commence the journey back to Indore (95 Kms).",
          ]
        },
      ]
    },
    {
      id: 7,
      name: "UJJAIN, MAHESHWAR",
      image: westBengalImg,
      size: "medium",
      duration: "3 Days / 2 Night",
      price: "₹0",
      images: [westBengalImg],
      about: "The journey begins in the ancient city of Ujjain, home to the Mahakaleshwar Jyotirlinga, before tracing the Narmada River to the sacred island of Omkareshwar and concluding in the historic ghats of Maheshwar.",
      highlights: ["Mahakaleshwar Temple", "Omkar Mandhata and Rajarajeshwara Temples.", "Maheshwar Fort and serene Narmada riverbanks"],
      included: [
        "	The costing is based on per person basis.",
        "	Meal plan as per hotel tariff",
        "	AC Sedan will be provided for 2 Pax and Innova Crysta will be given for 4 and above pax for all transfers – pickup from Nagpur to Drop at Bhopal."
      ],
      excluded: [
        "	Anything not mentioned in Inclusions",
        "	Safari charges are not included",
        "	Entry Fee for any sightseeing, Monuments etc",
        "	Air or Train Fare",

      ],
      itinerary: [
        {
          day: 1, 
          title: "Arrival at Indore", 
          description: [
            "Arrival at Indore Railway Station",
            "Warm welcome and breakfast/refreshments at the hotel",
            "Departure for Ujjain (55 Kms)",
            "Check-In at Hotel Shipra Residency and lunch",
            "Sightseeing and Darshan",
            "Evening Tea",
            "SEL Show Dinner",
            "Overnight stay at Hotel Shipra Residency"
          ]
        },
        {
          day: 2,
          title: "Ujjain Sightseeing",
          description: [
            "Breakfast at the hotel",
            "Half-day sightseeing in Ujjain",
            "Lunch",
            "Departure for Maheshwar (150 Kms)",
            "En-route visit Omkar Mandhata Temple and Siddhanath Temple in Omkareshwar (131 Kms)",
            "Arrival at Maheshwar",
            "Check-In at Hotel Narmada Resort",
            "Evening Tea",
            "Dinner",
            "Overnight stay at Hotel Narmada Resort"
          ]
        },
        {
          day: 3,
          title: "Maheshwar Exploration and Departure",
          description: [
            "Breakfast at the hotel",
            "Half-day sightseeing including a visit to Rajarajeshwara Temple and Maheshwar Fort",
            "Lunch",
            "Departure for Indore (95 Kms)"
          ]
        }
      ]
    },
    {
      id: 8,
      name: "Omkareshwar",
      image: tamilNaduImg,
      size: "medium",
      duration: "1 Day",
      price: "₹3,999",
      images: [tamilNaduImg],
      about: "Sacred island shaped like Om symbol.",
      highlights: ["Omkareshwar Temple", "Mamleshwar Temple", "Narmada Parikrama"],
      included: ["Guide", "Entry fees"],
      excluded: ["Hotel", "Transport"],
      itinerary: [{day: 1, title: "Temple Visit", description: "Spiritual tour"}]
    },
    {
      id: 9,
      name: "Jabalpur",
      image: rajasthanImg,
      size: "medium",
      duration: "2 Days / 1 Night",
      price: "₹8,999",
      images: [rajasthanImg],
      about: "Famous for marble rocks and Narmada river.",
      highlights: ["Bhedaghat Marble Rocks", "Dhuandhar Falls", "Boat Ride"],
      included: ["Hotel", "Breakfast", "Boat ride"],
      excluded: ["Transport", "Meals"],
      itinerary: [{day: 1, title: "Bhedaghat Tour", description: "Explore marble rocks"}]
    }
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    notes: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          location: selectedDestination.name,  // ✅ Send tour name as location
          notes: formData.notes,
          tourName: selectedDestination.name,
          tourPrice: selectedDestination.price,
          tourDuration: selectedDestination.duration
        }),
      });
  
      if (response.ok) {
        setFormSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          location: selectedDestination.name,
          notes: ''
        });
        
        // Reset success message after 5 seconds
        setTimeout(() => {
          setFormSubmitted(false);
        }, 5000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit enquiry. Please try again.');
    }
  };
  const destinations = [
    {
      id: 1,
      name: "Khajuraho",
      packages: "",
      image: madhyaPradeshImg,
      size: "large",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=khajuraho&zoom=12`
    },
    {
      id: 2,
      name: "Leh Ladakh",
      packages: "",
      image: lehLadakhImg,
      size: "medium",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=leh ladakh&zoom=12`
    },
    {
      id: 3,
      name: "Port Blair, Havelock Island",
      packages: "",
      image: andamanImg,
      size: "medium",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=Andaman and Nicobar Islands&zoom=10`
    },
    {
      id: 4,
      name: "Srinagar, Gulmarg",
      packages: "",
      image: kashmirImg,
      size: "medium",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=srinagar&zoom=12`
    },
    
    {
      id: 5,
      name: "Shimla, Manali",
      packages: "",
      image: himachalPradeshImg,
      size: "medium",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=shimla&zoom=10`
    },
    {
      id: 6,
      name: "Munnar, Kochi",
      packages: "",
      image: keralaImg,
      size: "medium" ,// Large card,
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=munnar&zoom=12`
    },
    {
      id: 7,
      name: "Darjeeling, Siliguri",
      packages: "",
      image: westBengalImg,
      size: "medium",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=darjeeling&zoom=12`
    },
    {
      id: 8,
      name: "Ooty, Kodaikanal",
      packages: "",
      image: tamilNaduImg,
      size: "medium",
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=ooty&zoom=12`
    },
    
    {
      id: 9,
      name: "Royal Rajasthan",
      packages: "",
      image: rajasthanImg,
      size: "large", // Large card,
      mapUrl:`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&q=jaipur&zoom=12`
    },
  ];

  // ✅ Handle destination click
  const handleDestinationClick = (destination) => {
    setSelectedDestination(destination);
    setCurrentImageIndex(0);
    document.body.style.overflow = 'hidden'; // Prevent background scroll
  };

  // ✅ Close modal
  const closeModal = () => {
    setSelectedDestination(null);
    document.body.style.overflow = 'auto';
  };

  // ✅ Image navigation in modal
  const nextImage = () => {
    if (selectedDestination) {
      setCurrentImageIndex((prev) =>
        prev === selectedDestination.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedDestination) {
      setCurrentImageIndex((prev) =>
        prev === 0 ? selectedDestination.images.length - 1 : prev - 1
      );
    }
  };

  // define testimonials avatar
  const DEFAULT_AVATAR =
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQAlgMBIgACEQEDEQH/xAAbAAEBAAIDAQAAAAAAAAAAAAAAAQIGAwQFB//EADkQAAICAgADBQQHBgcAAAAAAAABAgMEEQUGIRIxQVGhE2GRsSJScXJzweEUMjQ1QoEjJDM2YrLw/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD7iAAAAAAHBl5EMelznOMPJy/91A5tnVu4jiUPVl0e15Lq/Q1rOz7smbTum6/Ba7K+B0uncBti43gvutafvg1+R0reYlGTUMbtJf1e01v0Nf2QD3q+ZH217TG+j49me2e1iZdOZX7THmpLxXin70aNs5MXKtxL420y013rzXkBvgPNr41gyrhKd8YSkk3F76e471N9V8O3TZGcfOL2ByAAAAAAAAAAAAAOLIvhj0TtseowW2ahm5luZc7LH0/pj4RR73Mj/wAhHr32L5M1lsA2YsEAEYIwIRgjYBvodvg+W8TiFU+1qEn2Z9ejT6HSbMqrHVZGajGTXhJbT9wH0QHBhXxycWq6CajOKaT8DnAAAAAAAAAAADxuZ/4Or8X8ma0zZuZo7wIP6ti+TNYAEYI2BCMEbANmLYbIAINkZRvPAf5Ri/c/M9A6XBo9nhWJ+FF+h3SAAAAAAAAAAAPN5gj2uF2P6rT9TUNnocayrL862Lm/Zwl2Yx30Wjz2wIQEbANmLYbIAIwRsohGwTYH0XBh7PDx4fVrivQ5zUuUs21ZcsSc5OuUHKKb3pry/sbaQAAAAAAAAAABo3Ek48QyU119pL5nVZ73MuBJW/tlSbg1qzXh7zX9gVsxbGyACMEbKIRgjYBsxbDZi2B7PKacuMx1/TXJv0Ru54XK3DJ4dE8i+LjbbrUX3xj+p7pAAAAAAAAAAAEfVGv8z4cIYtV1NcY9iepdmOuj/X5mwnDlURyceymz92cey/cB8+IzkyqZ42ROm3pKEtfacTKIRgjANmLYbMWA2bzy/gV08Mx52VQdsk59qUVtb/TRqnBcF8Qz4V6fs4vtWP3H0GK0tJaXgQUAAAAAAAAAAAAAAAHg804Vc8T9s1q2rSb+st9zNSN35l/k1/2x+aNHfeUGzFsNmLAEk9IpjLuYR9B4Fg14ODWq+srEpzk+9tr5HonBhfwlH4cfkc5FAAAAAAAAARvSNf4lzGqrHVhQjPT07Jd39gNhOG/Kx8dbvurr+9JLZpWRxfPyP38mcV5Q+ivQ6Mm5NuXVvvbA3DJ5kwKtqt2XP/hHS+LPKyOaMmW1j011LzluTPCZGUdnK4jl5a1kZE5xffHeo/BHUbDZiwABGEQjBGB3sXjXEcVJVZU3FdFGz6S9T1sbm+2PTLxoTX1q3p/B7NZbIwN+xeZuGX9JWSpflbHXquh6tN9N8VKi2FkX4wkmj5Uy12Tqn26pyhLzi9MK+sbB85xuY+KY3T9p9pFeFq7Xr3+ps3A+ZauI2LHyK1TkNfR09xn9nk/cQbAAAPN5gyXjcLscNqU9QT8t9/ps0k2jm+WsXHj52N+n6mrARkYZGUGzFsNkYEAIwiEYIwDZi2GyMCEYIAIwRgGyRnKucZ1ycZxacZLwZGyMD6tgZCy8KjIWv8WCl8UDz+UZOfL2I34dtfCbQIrq84/6eL96X5GsMgAjMWUFGDAAEIyAIhiygDExYAEDIAIzFlAGLMWAB9F5M/2/R96f/ZgAiv/Z";
  const testimonials = [
  {
    quote:
      "",
    name: "",
    role: "",
    avatar: DEFAULT_AVATAR,
    accent: "green",
  },
  {
    quote:
      "",
    name: "",
    role: "",
    avatar: DEFAULT_AVATAR,
    accent: "blue",
  },
  {
    quote:
      "",
    name: "",
    role: "",
    avatar: DEFAULT_AVATAR,
    accent: "purple",
  },
  {
    quote:
      "",
    name: "",
    role: "",
    avatar: DEFAULT_AVATAR,
    accent: "red",
  },
];


  const trackRef = useRef(null);
  const mptrackRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [mpindex, setmpIndex] = useState(0);

  // How many cards are visible depends on breakpoint (1/2/3).
  const pages = useMemo(() => {
    const w = typeof window !== "undefined" ? window.innerWidth : 1024;
    if (w >= 1024) return 3; // lg
    if (w >= 768) return 2; // md
    return 1; // mobile
  }, []);

  const maxIndex = Math.max(0, testimonials.length - pages);
  const maxIndex1 = Math.max(0, mpdestinations.length - pages);
  

  const scrollToIndex = (i) => {
    const track = trackRef.current;
    if (!track) return;

    const clamped = Math.max(0, Math.min(i, maxIndex));
    const firstItem = track.querySelector(".testimonialCarouselItem");
    if (!firstItem) return;

    const step = firstItem.getBoundingClientRect().width;

    track.scrollTo({
      left: step * clamped,
      behavior: "smooth",
    });

    setIndex(clamped);
  };

  const scrollToIndex1 = (i) => {
    const track = mptrackRef.current;
    if (!track) return;

    const clamped = Math.max(0, Math.min(i, maxIndex1));
    const firstItem = track.querySelector(".mpdestination-card");
    if (!firstItem) return;

    const step = firstItem.getBoundingClientRect().width;

    track.scrollTo({
      left: step * clamped,
      behavior: "smooth",
    });

    setmpIndex(clamped);
  };

  useEffect(() => {
    const onResize = () => scrollToIndex1(mpindex);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mpindex])

  useEffect(() => {
    const onResize = () => scrollToIndex(index);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  return (
    <>
      {/* Hero Section with Background Image */}
      <section className="hero-section" id="hero">
        <div className="hero-background">
          <img 
            src={heroImage} 
            alt="Travel Adventure" 
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Find Your Perfect
              <span className="hero-title-highlight"> Destination</span>
            </h1>
            <p className="hero-description">
              Discover amazing places and create unforgettable memories with N N Travel Hub.
            </p>
          </div>


          {/* Horizontal Search Form - ✅ UPDATED */}
          <div className="search-form-container">
            <form className="horizontal-search-form" onSubmit={handleSearch}>
              
              {/* Location Field - ✅ Changed to SELECT dropdown */}
              <div className="search-field location-field">
                <div className="field-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="field-content">
                  {/* <label className="field-label">Location</label> */}
                  <select
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    className="field-input"
                    required
                    
                  >
                    <option value="">Select Destination</option>
                    <option value="India">India - All Destinations</option>
                    <optgroup label="Indian States & UTs">
                      <option value="Madhya Pradesh">Madhya Pradesh</option>
                      <option value="Uttar Pradesh">Uttar Pradesh</option>
                      <option value="Rajasthan">Rajasthan</option>
                      <option value="Gujarat">Gujarat</option>
                      <option value="Daman">Daman</option>
                      <option value="Maharashtra">Maharashtra</option>
                      <option value="Himachal Pradesh">Himachal Pradesh</option>
                      <option value="Jammu & Kashmir">Jammu & Kashmir</option>
                      <option value="Ladakh">Ladakh</option>
                      <option value="Uttarakhand">Uttarakhand</option>
                      <option value="Goa">Goa</option>
                      <option value="Kerala">Kerala</option>
                      <option value="Karnataka">Karnataka</option>
                      <option value="Tamil Nadu">Tamil Nadu</option>
                      <option value="Andhra Pradesh">Andhra Pradesh</option>
                      <option value="Andaman & Nicobar">Andaman & Nicobar</option>
                      <option value="West Bengal">West Bengal</option>
                    </optgroup>
                  </select>
                </div>
              </div>


              {/* Vertical Divider */}
              {/* <div className="field-divider"></div> */}


              {/* Check In Date */}
              {/* <div className="search-field date-field">
                <div className="field-icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <div className="field-content">
                  <label className="field-label">Date</label>
                  <input
                    type="date"
                    value={checkIn}
                    onChange={(e) => setCheckIn(e.target.value)}
                    className="field-input"
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div> */}


              {/* Arrow Icon */}
              {/* <div className="date-arrow">
                <i className="fas fa-arrow-right"></i>
              </div> */}


              {/* Check Out Date */}
              {/* <div className="search-field date-field">
                <div className="field-icon">
                  <i className="fas fa-calendar-check"></i>
                </div>
                <div className="field-content">
                  <label className="field-label">Check out</label>
                  <input
                    type="date"
                    value={checkOut}
                    onChange={(e) => setCheckOut(e.target.value)}
                    className="field-input"
                    min={checkIn || new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div> */}


              {/* Vertical Divider */}
              {/* <div className="field-divider"></div> */}


              {/* Search Button */}
              <button type="submit" className="search-button">
                Search
              </button>


            </form>
          </div>
        </div>
      </section>

      
      {/* About Section with Auto-Changing Images */}
      <section className="about-section-home" id="about"  style={{backgroundColor:`#dbecf2`,alignItems:`center`}} >        
          <div className="about-content-column"style={{backgroundColor:`powderblue` , boxShadow:`10px 10px 20px 0px rgba(0, 0, 0, 0.2`, padding:`0 10px 10px 0`, borderRadius:`20px`,alignItems:`center`}}>
            <div className="about-content">
              {/* Section Header */}
              <div className="about-header">
                <span className="about-subtitle" ><h2>ABOUT US</h2></span>
                <h2 className="about-title">N N Travel Hub</h2>
              </div>
              <div className="experience-badge" style={{textDecoration:`3d`}}>
                <div className="badge-number">10+</div>
                <div className="badge-text">
                  <div>Years of</div>
                  <div>Experience</div>
                </div>
              </div>
              {/* Description */}
              <div className="about-description">
                <p>
                  N N Travel Hub is a growing travel company based in Bhopal, Madhya Pradesh, proudly established in 2025. Backed by over 10 years of experience in the travel industry, we are committed to delivering smooth, memorable, and personalized travel experiences to our clients.
                  We specialize in curating exceptional journeys across India and international destinations, including holiday packages, cultural tours, wildlife adventures, luxury vacations, and spiritual pilgrimages. Our focus on quality service, careful planning, and customer satisfaction has helped us build strong relationships with a steadily expanding base of happy travelers.
                  At N N Travel Hub , we don’t just organize trips — we craft journeys you will cherish for a lifetime.
                </p>
              </div>

              {/* Services List with Checkmarks */}
              {/* <div className="about-services">
                {aboutServices.map((service, index) => (
                  <div key={index} className="service-item">
                    <div className="service-checkmark">
                      <i className="fas fa-check"></i>
                    </div>
                    <span className="service-name">{service}</span>
                  </div>
                ))}
              </div> */}

              {/* Discover More Button */}
              <div className="about-button">
                <button className="discover-btn" >
                  <a href="./About" target="_blank" rel="noopener noreferrer">Discover More</a>
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>

            </div>
          </div>
      </section>  

      {/* Separate Our Services Section - Below Hero */}
      {/* <section className="services-section" id="services">
        <div className="services-container">
          <div className="services-header">
            <h2 className="services-title">What We Offer</h2>
          </div>
          
          <div className="services-grid">
            {services.map((service) => (
              <div 
                key={service.id} 
                className="service-card"
                style={{ backgroundColor: service.bgColor }}
              >
                <div 
                  className="service-icon"
                  style={{ color: service.iconColor }}
                >
                  <i className={service.icon}></i>
                </div>
                <h3 className="service-title">{service.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="services-section" id="services">
  <div className="services-container">
    <div className="services-header">
      <h2 className="services-title">What We Offer</h2>
    </div>
    
    <div className="services-slider">
      <div className="slider-track">
        {/* Render original list + duplicated list for seamless loop */}
        {[...services, ...services].map((service, index) => (
          <div 
            key={`${service.id}-${index}`} 
            className="service-card"
            style={{ backgroundColor: service.bgColor, background:'transparent'}}
          >
            <div className="service-icon" style={{ color: service.iconColor, zIndex:`2`,backdropFilter:`blur(20)` } }>
              <i className={service.icon}></i>
            </div>
            <h3 className="service-title">{service.title}</h3>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>
       {/* ✅ MP Destinations Section with Click Handler */}
        <section className='mp-destination' id="mpdestinations">
          <div className="mp-destination-container">
            
            <div className="mpdestination-header">
              <div className="mpdestination-subtitle-wrapper">
                <div className="mpsubtitle-line"></div>
                <span className="mpdestination-subtitle" style={{ color: "#0072ff" }}>Madhya Pradesh</span>
                <div className="mpsubtitle-line"></div>
              </div>
              <h3 className="mpdestination-title">EXPLORE TOUR PACKAGES OF B2B MADHYA PRADESH</h3>
            </div>

            <div className="mpdestinations-grid" ref={mptrackRef} role="region">
              {mpdestinations.map((destination) => (
                <div 
                  key={destination.id} 
                  className={`mpdestination-card ${destination.size}`}
                  onClick={() => handleDestinationClick(destination)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="mpdestination-image-wrapper">
                    <img 
                      src={destination.image} 
                      alt={destination.name}
                      className="destination-image"
                    />
                    
                    <div className="mpdestination-overlay"></div>
                    
                    <div className="mpdestination-info">
                      <h3 className="mpdestination-name">{destination.name}</h3>
                      {/* <span className="destination-packages">{destination.duration}</span>
                      <span className="destination-price">{destination.price}</span> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
            type="button"
            className="mpdestinationsNav mpdestinationsNavPrev"
            onClick={() => scrollToIndex1(mpindex - 1)}
            aria-label="Previous mpdestinations"
          >
            <svg
              className="mpdestinationsNavIcon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <button
            type="button"
            className="mpdestinationsNav mpdestinationsNavNext"
            onClick={() => scrollToIndex1(mpindex + 1)}
            aria-label="Next mpdestinations"
          >
            <svg
              className="mpdestinationsNavIcon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
            
          </div>
        </section>
      
      <section className='top-destination' id="destinations">
      <div className="top-destination-container">
        
        {/* Section Header */}
        <div className="destination-header">
          <div className="destination-subtitle-wrapper">
            <div className="subtitle-line"></div>
            <span className="destination-subtitle" style={{ color: "#0072ff" }}>DESTINATIONS</span>
            <div className="subtitle-line"></div>
          </div>
          <h2 className="destination-title">TOP DESTINATIONS</h2>
          <p className="destination-description">
            Travel across India’s stunning destinations, from calm seaside escapes to scenic mountain views, with N N Travel Hub.
          </p>
        </div>

        {/* Destinations Grid */}
        <div className="destinations-grid" >
          {destinations.map((destination) => (
            <div 
              key={destination.id} 
              className={`destination-card ${destination.size}`}
              onMouseEnter={()=> setIsHovered(destination.id)}
              onMouseLeave={() => setIsHovered(false)}
              // style={{backgroundColor:`transparent` , perspective:`1000px`, height:`400px`} }
            >
              <div className="destination-card-inner"
                style={{position:`relative`, 
                  width:`100%`,
                  height:`100%`,
                   textAlign:`center`,
                   transition:`transform 1s`,
                   transformStyle:`preserve-3d`,
                   transform:isHovered===destination.id ? `rotateY(180deg)`: `rotateY(0)`
                  }}

              >
    
              {/* FRONT SIDE (Your existing content) */}
              <div className="destination-card-front"
                style={{position:`absolute`,
                  width:`100%`,
                  height:`100%`,
                  backface: `hidden`, /* Hides the back when the front is visible */
                  WebkitBackfaceVisibility:`hidden`,
                  borderRadius: `0.75rem`,
                  overflow: `hidden`,
                  // backgroundColor:`#bbb`
                }}
              >

              <div className="destination-image-wrapper">
                <img 
                  src={destination.image} 
                  alt={destination.name}
                  className="destination-image"
                  
                />
                <div className="destination-overlay"></div>
                
                {/* Destination Info */}
                <div className="destination-info">
                  <h3 className="destination-name">{destination.name}</h3>
                  <span className="destination-packages">{destination.packages}</span>
                </div>
              </div>
            </div>

            {/* BACK SIDE (The Map) */}
            <div className="destination-card-back"
              style={{position:`absolute`,
                  width:`100%`,
                  height:`100%`,
                  backface: `hidden`,
                  backfaceVisibility:`hidden`, /* Hides the back when the front is visible */
                  // backface: `hidden`,
                  borderRadius: `0.75rem`,
                  overflow: `hidden`,
                  backgroundColor:`#f1f1f1`,
                  color:`white`,
                  transform:`rotateY(180deg)`,
                  display:`flex`,
                  alignItems:`center`,
                  justifyContent:`center`,
                  WebkitBackfaceVisibility:`hidden`
                }}
            >
              <iframe
              
                title={`map-${destination.name}`}
                src={destination.mapUrl} // Add map URLs to your destinations array
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius:`0.75rem`, }}
                loading="lazy"
              ></iframe>
            </div>
            </div>
            </div>
          ))}
          
          {/* Explore India Card */}
          <div className="destination-card explore-card">
            <div className="explore-content">
              {/* <h3 className="explore-title">EXPLORE INDIA</h3> */}
              {/* <p className="explore-description">
                India, a country of diverse heritage, from ancient temples to colonial architecture. 
                Its landscapes range from serene coastlines to towering mountains, 
                complemented by lush national parks.
              </p> */}
              <button className="explore-btn">
                <a href="./India" target="_blank" rel="noopener noreferrer">Explore More</a>
                <div className="explore-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
        
      </div>
    </section>
    {/* testimonial section */}
    <section id="testimonials" className="testimonialsSection">
      <div className="testimonialsContainer">
        <h2 className="testimonialsTitle">What Our Clients Say</h2>

        <div className="testimonialsCarouselWrap">
          <div
            ref={trackRef}
            className="testimonialCarousel"
            role="region"
            aria-label="Testimonials"
          >
            {testimonials.map((t) => (
              <div key={t.name} className="testimonialCarouselItem">
                <div className="testimonialCard">
                  <p className="testimonialQuote">{t.quote}</p>

                  <div className="testimonialUser">
                    <img
                      src={t.avatar}
                      alt={`${t.name} avatar`}
                      
                      className={`testimonialAvatar testimonialAvatar--${t.accent}`}
                      loading="lazy"
                    />
                    <div>
                      <p className="testimonialName">{t.name}</p>
                      <p className={`testimonialRole testimonialRole--${t.accent}`}>
                        {t.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            type="button"
            className="testimonialNav testimonialNavPrev"
            onClick={() => scrollToIndex(index - 1)}
            aria-label="Previous testimonial"
          >
            <svg
              className="testimonialNavIcon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <button
            type="button"
            className="testimonialNav testimonialNavNext"
            onClick={() => scrollToIndex(index + 1)}
            aria-label="Next testimonial"
          >
            <svg
              className="testimonialNavIcon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
    {/* ✅ MODAL for MP Destinations */}
      {selectedDestination && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            
            {/* Image Slider */}
            <div className="image-slider">
              <img
                src={selectedDestination.images[currentImageIndex]}
                alt={selectedDestination.name}
              />
              <button className="slider-btn prev" onClick={prevImage}>‹</button>
              <button className="slider-btn next" onClick={nextImage}>›</button>
              
              <div className="image-indicators" style={{ color: "#0072ff" }}>
                {selectedDestination.images.map((_, index) => (
                  <span
                    key={index}
                    className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)} 
                    style={{ color: "#0072ff" }}
                  ></span>
                ))}
              </div>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <h2 className="modal-tour-title">{selectedDestination.name}</h2>
              <p className="modal-tour-duration">
                {selectedDestination.duration} • {selectedDestination.price}
              </p>

              {/* About */}
              <div className="detail-section">
                <h3>About This Tour</h3>
                <p>{selectedDestination.about}</p>
              </div>

              {/* Highlights */}
              <div className="detail-section">
                <h3>Tour Highlights</h3>
                <ul className="highlights-list">
                  {selectedDestination.highlights.map((highlight, index) => (
                    <li key={index}>
                      <i className="fas fa-star" style={{ color: "#0072ff" }}></i> {highlight}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Included/Excluded */}
              <div className="detail-section">
                <h3>What's Included & Excluded</h3>
                <div className="included-excluded-grid">
                  <div className="included-col">
                    <h4><i className="fas fa-check-circle"></i> Included</h4>
                    <ul>
                      {selectedDestination.included.map((item, index) => (
                        <li key={index}>
                          <i className="fas fa-check"></i> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="excluded-col">
                    <h4><i className="fas fa-times-circle"></i> Excluded</h4>
                    <ul>
                      {selectedDestination.excluded.map((item, index) => (
                        <li key={index}>
                          <i className="fas fa-times"></i> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Itinerary */}
              <div className="detail-section">
                <h3>Day-by-Day Itinerary</h3>
                <div className="itinerary-list">
                  {selectedDestination.itinerary.map((day) => (
                    <div key={day.day} className="itinerary-item">
                      <div className="itinerary-header">
                        <div>
                          <span className="day-num">Day {day.day}</span>
                          <span className="day-title"> - {day.title}</span>
                        </div>
                      </div>
                      <div className="itinerary-content">
                        {Array.isArray(day.description) ? (
            <ul className="itinerary-points">
              {day.description.map((point, index) => (
                <li key={index}>
                  <i className="fas "></i> {point}
                </li>
              ))}
            </ul>
          ) : (
                        <p>{day.description}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <section className="detail-section">
  <h3>Book This Tour</h3>
  <div className="enquiry-contact-grid" style={{marginLeft:`0`}}>
    {/* Enquiry Form - Left Side */}
    <div className="enquiry-form-card" style={{width:`100%`}}>
      <h4>Send Enquiry</h4>
      {formSubmitted ? (
        <div className="success-message">
          <i className="fas fa-check-circle"></i>
          <h5>Thank You!</h5>
          <p>We have received your enquiry. Our team will get back to you within 24 hours.</p>
        </div>
      ) : (
        <form onSubmit={handleFormSubmit} className="enquiry-form">
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleFormChange}
              placeholder="Your full name"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleFormChange}
              placeholder="your.email@example.com"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Phone *</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleFormChange}
              placeholder="+91 XXXXX XXXXX"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Selected Tour</label>
            <input
              type="text"
              name="TourName"
              value={selectedDestination.name}
              readOnly
              className="readonly-input"
            />
          </div>
          
          <div className="form-group">
            <label>Additional Requirements</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleFormChange}
              placeholder="Tell us about any special requirements, preferences, or questions..."
              rows="4"
            ></textarea>
          </div>
          
          <button type="submit" className="submit-enquiry-btn">
            <i className="fas fa-paper-plane"></i> Send Enquiry
          </button>
        </form>
      )}
    </div>

    {/* Contact Information - Right Side */}
    <div className="contact-info-card">
      <h4>Contact Information</h4>
      <div className="contact-details">
        <div className="contact-item">
          <div className="contact-icon">
            <i className="fas fa-envelope"></i>
          </div>
          <div className="contact-text">
            <span className="contact-label">Email</span>
            <a href="mailto:info@nntravelhub.com">info@nntravelhub.com</a>
          </div>
        </div>
        
        <div className="contact-item">
          <div className="contact-icon">
            <i className="fas fa-phone-alt"></i>
          </div>
          <div className="contact-text">
            <span className="contact-label">Phone</span>
            <a href="tel:+919876543210">+91 7354251333</a>
          </div>
        </div>
        
        <div className="contact-item">
          <div className="contact-icon">
            <i className="fas fa-globe"></i>
          </div>
          <div className="contact-text">
            <span className="contact-label">Website</span>
            <a href="https://nntravelhub.com" target="_blank" rel="noopener noreferrer">
              www.nntravelhub.com
            </a>
          </div>
        </div>
        
        <div className="contact-item">
          <div className="contact-icon">
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <div className="contact-text">
            <span className="contact-label">Address</span>
            <p>N N Travel Hub, Bhopal<br/>Madhya Pradesh, India</p>
          </div>
        </div>
      </div>
      
      <div className="contact-hours">
        <h5><i className="fas fa-clock"></i> Business Hours</h5>
        <p>Monday - Saturday: 9:00 AM - 7:00 PM<br/>Sunday: 10:00 AM - 5:00 PM</p>
      </div>
      
      <div className="social-links">
        <h5>Follow Us</h5>
        <div className="social-icons">
          <a href="facebook.com" target="_blank"><i className="fab fa-facebook-f"></i></a>
          <a href="instagram.com" target="_blank"><i className="fab fa-instagram"></i></a>
          <a href="twitter.com" target="_blank"><i className="fab fa-twitter"></i></a>
          {/* <a href="#" target="_blank"><i className="fab fa-whatsapp"></i></a> */}
        </div>
      </div>
    </div>
  </div>

  <a href="https://wa.me/917354251333" className="whatsapp-float" target="_blank" rel="noreferrer" aria-label="Chat with us on WhatsApp">
    <i className="fab fa-whatsapp"></i>
  </a>
</section>

            </div>
            
            </div>
            
        </div>
        
        
      )}
      
    </>
  );
};

export default Hero;
